var $d950967017e3485b$exports = {};
$d950967017e3485b$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "V\xE4rvivalija",
  "colorSwatch": "v\xE4rvin\xE4idis",
  "transparent": "l\xE4bipaistev",
  "twoDimensionalSlider": "2D-liugur"
};
export { $d950967017e3485b$exports as default };